export enum TypesEnum {
    apiCallBegan = 'api/CALL_BEGAN',
    apiCallSuccess = 'api/CALL_SUCCESS',
    apiCallFailed = 'api/CALL_FAILED',
}

export type ApiCall = {
    url: string;
    method: string;
    safe: boolean;
    params?: Record<string, any>;
    body?: Record<string, any>;
    onStart?: string;
    onSuccess?: string;
    onError?: string;
};

export interface ApiCallBegan {
    type: TypesEnum.apiCallBegan;
    payload: ApiCall;
}

export interface ApiCallSuccess {
    type: TypesEnum.apiCallSuccess;
    payload: any;
}

export interface ApiCallFailed {
    type: TypesEnum.apiCallFailed;
    payload: any;
}

export type ApiCallActionTypes = ApiCallBegan | ApiCallSuccess | ApiCallFailed;
